<template>
    <div>
        <template v-if="view === 'form'">
            <AuthForm 
                auth-type="initiateReset" 
                show-form-img
                :loading="loading" 
                :error="error" 
                @form-submit="handleReset"
            >
                <template #icon>
                    <AuthResetIcon />
                </template>
            </AuthForm>
        </template>

        <template v-else>
            <div class="auth__form__wrap">
                <div class="follow__up__preview">
                    <p class="text--semi--bold text-gray-800 mb--10 text--md">
                        Email sent!
                    </p>

                    <p class="text--sm mb--10 text-gray-400">
                        We sent an email to you with a reset link.
                    </p> 

                    <p class="text--sm mb--10 text-gray-400">
                        If there is a matching account associated with the email address entered, you should get an email from us within the next couple of minutes. 
                    </p> 

                    <p class="text--sm mb--10 text-gray-400">
                        Still having trouble logging in? You can support by sending an email to <span class="text--underline text-gray-400">
                            support@ziner.cc
                        </span>
                    </p>

                    <div class="mt--15 flex align-items-center">
                        <BaseButton 
                            variant="ghost" 
                            variant-style="primary" 
                            label="Use a different email address" 
                            class="text--sm p--0 text--semi--bold" 
                            @submit="view = 'form'"  
                        />
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import AuthForm from "@/components/auth/AuthForm.vue";
import { BaseButton } from "@/components/ui/index";
import envs from "@/config/env";
import AuthResetIcon from "@/components/ui/icons/AuthResetIcon.vue";

export default {
    name: "InitiateResetPage",
    components: {
        AuthForm, BaseButton, AuthResetIcon,
    },

    data() {
        return {
            error: {
                show: false,
                value: "",
            },
            loading: false,
            view: "form",
        };
    },

    computed: {
        isBtnDisabled() {
            if (!this.email) {
                return true;
            } else if (this.loading) {
                return true;
            } else {
                return false;
            }
        },
    },

    methods: {
        async handleReset(data) {
            try {
                this.error.show = false;
                this.error.value = "";
                this.loading = true;

                const redirectUrl = `${envs.VUE_APP_CLIENT_URL}/auth/reset`;

                await this.$store.dispatch("auth/initiatePasswordRequest", { redirectUrl, email: data.email });

                this.view = "success_message";
            } catch (error) {
                const errMsg = error?.response?.data?.message || error?.message;
                
                this.error.value = errMsg;
                this.error.show = true;
                this.$toast.error(errMsg);
            } finally {
                this.loading = false;
            };
        },
    },
};
</script>

<style lang="scss" scoped>
.auth--form__wrap {
    padding: 20px 40px 35px;
}
</style>